/************************************************/
/* This file is autogenerated from Enums in Foundations Code.*/
/* Its supposed to maintain consistency between C# code and frontend. */
/* Please do not edit this. Thanks! */
export namespace FoundationsEnums {

	export enum ResponseStatus {
		Success = 0,
		InvalidEmail = 1,
		InvalidPassword = 2,
		UserNotFound = 3,
		PropertyNotFound = 4,
	}
	export enum DeviceType {
		Reserved = 0,
		iPhone = 1,
		Android = 2,
		AndroidTablet = 3,
		iPad = 4,
		OtherPhone = 5,
		Browser = 999,
		Unknown = -1,
	}
	export enum StatusOfRequests {
		To_Be_Reviewed = 1,
		Closed = 2,
		Provide_Information = 3,
		To_Be_Completed = 4,
		To_Be_Tested = 5,
		To_Be_Pushed_To_Production = 6,
		To_Be_Closed = 7,
		Blocker_TO_BE_RESOLVED = 8,
	}
	export enum FunctionalModule {
		Snapshots = 0,
		CustomerBrandingAssets = 1,
		HelpAttachmentDocument = 2,
		ExportedDrillThru = 3,
		ExportedCharts = 4,
		ExportedReportCSV = 5,
		StructuredReportPdf = 6,
		ContentGuides = 7,
		CCDArchive = 8,
		Builds = 9,
		FoundationsNativeAppLogs = 10,
		AnnouncementAttachmentDocument = 11,
		Exports = 12,
		Unknown = -1,
	}
	export enum AppSetting {
		ApplicationStatus = 0,
		AppCustomerGuid = 1,
		MainWebsiteFullURL = 2,
		ApplicationFullURL = 3,
		AppDataDatabaseName = 4,
		AppLoadDatabaseName = 5,
		AppCustomerDatabaseName = 6,
		SmtpSendEmail = 7,
		SmtpServerName = 8,
		SmtpServerPort = 9,
		SmtpServerEnableSSL = 10,
		SmtpServerAuthUserName = 11,
		SmtpServerAuthUserPassword = 12,
		SmtpFromEmailLabel = 13,
		SmtpFromEmailAddress = 14,
		SmtpToEmailLabel = 15,
		SmtpToEmailAddress = 16,
		SmtpUseTestAccount = 17,
		SmtpTestEmailLabel = 18,
		SmtpTestEmailAddress = 19,
		SmtpUseCcEmail = 20,
		SmtpCcEmailLabel = 21,
		SmtpCcEmailAddress = 22,
		BackgroundWorklistSync = 23,
		BackgroundWorklistSync_Out = 24,
		BackgroundWorklistSync_In = 25,
		SupportContactEmail = 26,
		SupportContactLabel = 27,
		SupportContactSubject = 28,
		AnalyticsDown = 29,
		NotificationNodeEnabled = 30,
		AWSAccessKey = 31,
		AWSSecretKey = 32,
		SessionTimeout = 33,
		ALObjectsBasePath = 34,
		NightlyEmailNotifications = 35,
		CleanUpThread = 36,
		MLPSVOut = 37,
		MLAPIURL = 38,
		MLReportAPIToken = 39,
		SelfSignedSSL = 40,
		Environment = 41,
		ApplicationBasePath = 42,
		QueryTimeOut = 43,
		HLMaintenanceTime = 44,
		VUCacheSize = 45,
		IntegrationTestUser = 46,
		IntegrationTestPassword = 47,
		PlatformCleanup = 48,
		Version = 49,
		ReleasePopup = 50,
	}
	export enum WLMStatus {
		Unknown = 0,
		Open = 1,
		Closed = 2,
		Accepted = 3,
		Declined = 4,
		Deleted = 5,
	}
	export enum InternalError {
		ImmediateAction = 0,
		Critical = 1,
		High = 2,
		Medium = 3,
		Low = 4,
		Annoyance = 5,
	}
	export enum EncodeType {
		HTMLEncode = 1,
		URLEncode = 2,
	}
	export enum DecodeType {
		HTMLDecode = 1,
		URLDecode = 2,
	}
	export enum RequestMethodType {
		Dynamic = 1,
		QueryString = 2,
		FormPost = 3,
	}
	export enum AuthType {
		Unknown = 0,
		Session = 1,
		APIToken = 2,
		AuthToken = 3,
		UserId = -1,
	}
	export enum NotificationObjectType {
		Reserved = 0,
		Patient = 1,
		WorkSpace = 2,
		Report = 3,
		FinancialTransaction = 4,
		CaseNote = 5,
		Snapshot = 6,
		SnapshotComment = 7,
		UserConfirmed = 8,
		UserRegistered = 9,
		DataSourceUpload = 10,
		DimensionNotification = 11,
		AdministratorNotificationforRole = 12,
		AdministratorNotificationforUser = 13,
		AdministratorNotificationforAllUser = 14,
		HelpRequestAdded = 15,
		HelpRequestUpdated = 16,
		HelpNoteAdded = 17,
		HelpNoteDeleted = 18,
		WLMNotification = 19,
		LeaveNegotiatedNotification = 20,
		LeaveCreatedNotification = 21,
		Announcement = 22,
		ExternalNotification = 23,
		GlobalTarget = 24,
	}
	export enum NotificationAction {
		Reserved = 0,
		Create = 1,
		Share = 2,
	}
	export enum NotificationRecipientType {
		Individual = 0,
		Role = 1,
		SharedWith = 2,
		SharedAndRole = 3,
		UserType = 4,
		HelpRequest = 5,
	}
	export enum SubscriptionType {
		Individual = 0,
		RoleBased = 1,
	}
	export enum UserPreference {
		ShowFirstTimeHelpWorkspace = 0,
		CurrentDashBoardId = 1,
		TempVUNumber = 2,
		EmailSummaryReport = 3,
		EmailNewNotes = 4,
		EmailNewDictValues = 5,
		EmailListenerActivity = 6,
		UserFavWorkspace = 7,
		DeveloperMode = 8,
	}
	export enum UserType {
		InvalidUser = 0,
		SystemAdmin = 1,
		CustomerAdmin = 2,
		PowerUser = 3,
		SimpleUser = 4,
	}
	export enum DataMapperTool {
		GetFormDataTool = 99,
		PostFormDataTool = 100,
		PostSendNotiDataTool = 109,
	}
	export enum DataMapperToolAction {
		Read = 0,
		Post = 1,
		Audit = 2,
	}
	export enum UserStatus {
		Unknown = 0,
		Registered = 1,
		Confirmed = 2,
		Approved = 3,
		Rejected = 4,
		Deleted = 5,
		AutoApproved = 6,
	}
	export enum PrivacyLock {
		OpenUnlocked = 0,
		LockedNotPrivate = 1,
		PrivateNotVisible = 2,
		EverythingBetterThanImpossible = 999,
	}
	export enum DashBoardShareType {
		Unknown = 0,
		Personal = 1,
		ByRole = 2,
		Shared = 3,
	}
	export enum VisualUnitViewerType {
		Unknown = 0,
		Table = 1,
		SVU = 2,
		Chart_Pie = 3,
		Chart_Bar = 4,
		Chart_Line = 5,
		Chart_StackedBar = 6,
		Chart_ColumnGroup = 7,
		Chart_Scatter = 8,
		HeatMap = 9,
		Chart_StackedColumn = 10,
		WorkList = 11,
		Gauge = 12,
		WorkListWithoutGauge = 13,
		ActivePanel = 999,
	}
	export enum ChartSeriesType {
		ColumnAsSeries = 1,
		RowAsSeries = 2,
	}
	export enum ChartVariationType {
		C_1M_1X_or_1Y = 0,
		C_1M_1X_and_1Y = 1,
		C_1M_2X_or_2Y = 2,
		C_1M_2X_and_1Y = 3,
		C_1M_1X_and_2Y = 4,
		C_1M_2X_and_2Y = 5,
		C_2M_1X_or_1Y = 6,
		C_2M_1X_and_1Y = 7,
		C_3M_1X_or_1Y = 8,
		C_3M_1X_and_1Y = 9,
		C_4M_1X_or_1Y = 10,
		C_4M_1X_and_1Y = 11,
		C_5M_1X_or_1Y = 12,
		C_5M_1X_and_1Y = 13,
		C_NM_1D = 14,
		C_NM_2D = 15,
		C_NM_1X_or_1Y = 16,
		C_NM_1X_and_1Y = 17,
		C_NM_2X_and_0Y = 18,
		C_NM_0X_and_2Y = 19,
	}
	export enum HLOperation {
		Invalid = 0,
		AdminTasks = 1,
		AdminTasks_RunQuery = 2,
		AdminTasks_ManageUsers = 3,
		AdminTasks_ManageRoleDashboards = 4,
		AdminTasks_ManageMetadata = 5,
		Workspace_Add = 6,
		Workspace_Edit = 7,
		Workspace_Delete = 8,
		Workspace_Share = 9,
		Workspace_AddVisualUnit = 10,
		Workspace_RemoveVisualUnit = 11,
		Workspace_Notes = 12,
		Workspace_Reorder = 13,
		Workspace_Detach = 14,
		VisualUnit_Add = 15,
		VisualUnit_Edit = 16,
		VisualUnit_Delete = 17,
		Snapshots = 18,
		Snapshots_Feed = 19,
		UpdatePresetTarget = 20,
		ChangeAnotherUsersPassword = 21,
		Unknown = 22,
		AllowDataExport = 23,
		AllowPatientLookup = 24,
		AllowDataFix = 25,
		AllowUserNote = 26,
		AllowStatPortal = 27,
		AllowContentGuideViewing = 28,
		AllowContentGuideEditing = 29,
		AllowContentGuidePublishing = 30,
		AllowVisualUnitLockedFilterExplore = 31,
		AllowAssignDefaultView = 32,
		AllowAssignDefaultDrillView = 33,
		AllowAssignDefaultReportView = 34,
		AllowHelpRequest = 35,
		AllowHelpAdmin = 36,
		ManageDimension = 37,
		HelpRequestModule = 38,
		HelpRequestCreate = 39,
		HelpRequestRead = 40,
		HelpRequestUpdate = 41,
		HelpRequestDelete = 42,
		AllowClinicalReportsView = 43,
		AllowClinicalReportsEdit = 44,
		VisualUnit_Refine = 45,
		WorkloadManager = 46,
		WorkloadRequester = 47,
		AllowProxyUser = 48,
		AllowDrillThruLaunch = 49,
		AllowProtocolFormApprove = 50,
		AllowExportPDF = 51,
		AllowExportExcel = 52,
		AllowExportJSON = 53,
		ForceDataGovernance = 54,
		AllowWorkspace_List_All = 55,
		AllowWorkList = 56,
		CreateDrillThruSet = 57,
		AllowDrillThruSetSwitch = 58,
		AdminTasks_tools = 59,
		ShowEngineDetails = 60,
		AllowHelpRequestAssignableUser = 61,
		AllowMDSColsCustomConfig = 62,
		AllowSecuredBusinessParameter = 63,
		AllowProtocolFormSpecialityCare = 64,
		AllowExtendingSessionWithoutUserInteraction = 65,
		AllowClinicalReportAddendum = 66,
		LeaveRequestManager = 67,
		Workspace_LockAllReports = 68,
		AllowSendNotification = 69,
		AllowBusinessParameterNotification = 70,
		AllowUploadFiles = 71,
		AllowVisualUnit_List_All = 72,
		AllowAdminEmailPreference = 73,
		AllowChangePresetTarget = 74,
		CustomerAdmin = 75,
		LeaveRequestNotification = 76,
		AllowTools_CustomerAdmin = 77,
		AllowTools_Foundations = 78,
		DeveloperMode = 79,
	}
	export enum RequestPriority {
		STAT = 1,
		High = 2,
		Medium = 3,
		Low = 4,
		Unknown = -1,
	}
	export enum WLMPriority {
		STAT = 1,
		Routine = 2,
	}
	export enum TypeOfRequest {
		Bug = 1,
		Feature_Request = 2,
		Question = 3,
		Task = 4,
	}
	export enum FunctionalArea {
		Mobile = 1,
		Browser = 2,
		Sign_In = 3,
		Authorization = 4,
		Forms = 5,
		Drill_Thru = 6,
		Reports = 7,
		Workspaces = 8,
		Summary = 9,
		Notifications = 10,
		Admin_Tools = 11,
		Data = 12,
		Data_Fix = 13,
		Other = 14,
		Unknown = -1,
	}
	export enum BinType {
		HLCaseSplit = 0,
		HLMeasureSpliter = 1,
	}
	export enum HLDataType {
		None = 0,
		HLCount = 1,
		HLMoney = 2,
		HLDuration = 3,
		HLList = 4,
		HLSearchList = 5,
		HLAge = 6,
		HLYear = 7,
		HLPercentage = 8,
		HLMonth = 9,
		HLDate = 10,
		HLTime = 11,
		HLText = 12,
		HLAgeDays = 13,
		HLNumber = 14,
		HLDecimal = 15,
		HLBusinessParameter = 16,
		HLSingleValueReport = 17,
		HLBooleanTF = 18,
		HLYesNo = 19,
		HLMeasureSet = 20,
	}
	export enum HLFilterValueType {
		None = 0,
		Second = 1,
		Minute = 2,
		Hour = 3,
		Day = 4,
		Month = 5,
		Quarter = 6,
		Year = 7,
	}
	export enum HLAggregateFunction {
		None = 0,
		Average = 1,
		Maximum = 2,
		Minimum = 3,
		Total = 4,
		STDEV = 5,
		STDEVP = 6,
		Median = 7,
		FirstQuartile = 8,
		ThirdQuartile = 9,
		Percentile90th = 10,
		Percentile10th = 11,
		Value = 12,
		CumulativeTotal = 13,
		WeightedAverage = 14,
	}
	export enum DeleteMode {
		Check = 1,
		Delete = 2,
	}
	export enum HLMetaDataValueType {
		Default = 0,
		Filter = 1,
		UserSetting = 2,
	}
	export enum NotificationType {
		Unknown = 0,
		Fad_Reserved = 1,
		FoundationsSpecific = 2,
		CustomerMessage = 3,
		StaffAlert = 4,
		SummaryTarget = 5,
		SummaryRangeCross = 6,
		TagPatient = 7,
		PatientRecord = 8,
		HLList = 9,
		Comment = 10,
		UserAccount = 11,
		ShareWorkspace = 12,
		InvitePerson = 13,
		FinancialNote = 14,
		AccountingAction = 15,
	}
	export enum NotificationSubType {
		Unknown = 0,
		Create = 1,
		Read = 2,
		Update = 3,
		Delete = 4,
		PatientCondition = 5,
		PatientAction = 6,
		PatientFinancial = 7,
	}
	export enum RubricRangeType {
		Higher = 1,
		Between = 2,
		Lower = 3,
	}
	export enum SqlDataType {
		None = 0,
		Int = 1,
		Decimal = 2,
		Text = 3,
		Date = 4,
		Time = 5,
	}
	export enum SqlJoinType {
		Inner = 0,
		Left = 1,
		Right = 2,
	}
	export enum ReplaceType {
		Substitute = 1,
		EscapeDoubleQuote = 2,
		EscapeSingleQuote = 4,
		MapNewLine = 8,
		MapQuote = 16,
		MapSingleQuote = 32,
		MapDoubleQuote = 64,
		UrlEncode = 128,
	}
	export enum ContentGuideAuditType {
		None = 0,
		SignInSuccess = 1,
		SignInFailure = 2,
		SignInAttempt = 3,
		MeasureLoaded = 4,
		MeasureUnLoaded = 5,
		CureatrLaunching = 6,
		CureatrLaunchingInMarket = 7,
		CureatrLaunchError = 8,
		ContentGuidePublish = 9,
	}
	export enum AuditRefType {
		Unknown = 0,
		UserId = 1,
		DashBoardId = 2,
		VisualUnitId = 3,
		NoteId = 4,
	}
	export enum SortOrder {
		Ascending = 1,
		Descending = 2,
		System = 3,
	}
	export enum SortOrderViewType {
		Table = 0,
		Chart = 1,
	}
	export enum ListenerType {
		UNKNOWN = 0,
		DICOM = 1,
		HL7 = 2,
		ICS = 3,
		XLS = 4,
		XML = 5,
		CSV = 6,
		PSV = 7,
		TXT = 8,
		PDF = 9,
	}
	export enum XMLLogType {
		Information = 0,
		Error = 1,
		Success = 2,
	}
	export enum TargetType {
		NotSet = 0,
		StayUnder = 1,
		StayCloseTo = 2,
		AimToExceed = 3,
		SystemDefined = 4,
	}
	export enum ModelContext {
		Patient = 0,
		Encounter = 1,
		Procedure = 2,
		WorkflowState = 3,
		CaseNote = 4,
		Clinical = 5,
		Financial = 6,
	}
	export enum BusinessParameterScope {
		SystemWide = 0,
		Department = 1,
		User = 2,
	}
	export enum AxisSubType {
		None = 0,
		BP = 1,
		SVR = 2,
		MeasureSet = 3,
	}
	export enum AppDimensionFieldType {
		Unknown = 0,
		Text = 1,
		Integer = 2,
		Decimal = 3,
		DateTime = 4,
		Pulldown = 5,
		Boolean = 6,
	}
	export enum QueryStatusType {
		Reserved = 0,
		Success = 1,
		Failure = 2,
		InputError = 3,
		Unknown = -1,
	}
	export enum ContentGuideLookupKind {
		Undefined = 0,
		All = 1,
		ById = 2,
		Search = 3,
	}
	export enum RenderMode {
		Serverside = 0,
		Javascript = 1,
	}
	export enum DigitalAssetType {
		Images = 0,
		PDFs = 1,
	}
	export enum DashboardType {
		Workspace = 0,
		ContentGuideLauncher = 1,
		AppLauncher = 2,
	}
	export enum NoteType {
		Note = 1,
		Attachment = 2,
	}
	export enum APIConditionType {
		SEARCH_STRING = 0,
		USER_STATUS = 1,
	}
	export enum FormType {
		ProtocolForm = 0,
		PatientFlow = 1,
	}
	export enum MetaData {
		AuditedUser = 14,
		RoleMetaData = 71,
		TimeZoneMetadata = 101010,
	}
	export enum AutoTestStatus {
		Reserved = 0,
		InProgress = 1,
		Success = 2,
		Failed = 3,
		UnKnown = -1,
	}
	export enum OperationType {
		Reserved = 0,
		Insert = 1,
		Update = 2,
		UnKnown = -1,
	}
	export enum ScopeType {
		Reserved = 0,
		Global = 1,
		User = 2,
		Role = 3,
		UnKnown = -1,
	}
	export enum RunType {
		Reserved = 0,
		D = 1,
		R = 2,
		UnKnown = -1,
	}
	export enum HomePageWorkspaceType {
		Reserved = 0,
		MyKmi = -4,
		NotificationsReport = -3,
		MyFav = -2,
		Unknown = -1,
	}
	export enum CloudServiceProviders {
		Reserved = 0,
		AWS = 1,
		REMOTEFILESYSTEM = 2,
		Unknown = -1,
	}
	export enum FoundationsFeatures {
		Reserved = 0,
		MetadataDrillthruSetTool = 1,
		AutomatedDeploymentManager = 2,
		Unknown = -1,
	}
	export enum ProxyRole {
		Reserved = 0,
		Proxier = 1,
		Proxied = 2,
		Unknown = -1,
	}
	export enum LMS_LeaveRequestStatus {
		Reserved = 0,
		Approved = 1,
		Decline = 2,
		Negotiate = 3,
		RequestPending = 4,
		New = 5,
		Drafted = 6,
		Withdrawn = 7,
	}
	export enum Authentication {
		OpenID = 0,
		Foundations = -1,
	}
	export enum DisplayMode {
		Reserved = 0,
		Unset = 1,
		Classic = 2,
		Night = 3,
		Unknown = -1,
	}
	export enum Status {
		Success = 0,
		Failure = 1,
		Unauthorized = 2,
	}
	export enum MessageResultFieldTypes {
		AddContactSupport = 0,
		AddDimensionRow = 1,
		AddNewDashBoard = 2,
		AddRoleDashBoard = 3,
		AdminTool = 4,
		AddExistingVisualUnit = 5,
		AddHelpRequest = 6,
		BrowserDetails = 7,
		ChangeUserPassword = 8,
		CreateVisualUnitInt = 9,
		DetachDashboard = 10,
		EditAppDimensionRow = 11,
		EmailConfirmation = 12,
		EditDashBoard = 13,
		EditSaveVisualUnit = 14,
		EmailNotifications = 15,
		FilterAppDimensionRows = 16,
		GetAppDimension = 17,
		GetAppDimensionValues = 18,
		GetAppDimensionRow = 19,
		InitiateResetPassword = 20,
		Invite = 21,
		LeaveManager = 22,
		OperationNotAllowed = 23,
		UserLocation = 24,
		PasswordVerification = 25,
		RemoveVisualUnitFromDashBoard = 26,
		Rubric = 27,
		Register = 28,
		SendConfirmRegistration = 29,
		SignIn = 30,
		SaveAsNewVisualUnit = 31,
		UserAccount = 32,
		UserSetNewPassword = 33,
		VisualUnitTarget = 34,
		VisualPreview = 35,
		VisualUnitAlreadyExists = 36,
	}
	export enum currentPageView {
		RegisterPage = 0,
		AboutTAndCPage = 1,
		ContactPage = 2,
		HomePage = 3,
		VisualUnitsPage = 4,
		InvitePage = 5,
		UserSettingsPage = 6,
		ManageUsersPage = 7,
		ManageRolesPage = 8,
		Log4netPage = 9,
		GenericAdminTools = 10,
		FormsEngineSkeleton = 11,
		DefaultViewPages = 12,
	}
	export enum departments {
		Radiology = 1,
		Cardiology = 2,
	}
	export enum InitializationState {
		None = 0,
		Address = 1,
		Port = 2,
		All = 3,
	}

}

/************************************************/
